import React, { useState, useRef, useEffect } from "react";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { OverlayPanel } from 'primereact/overlaypanel';
import { Link } from "react-router-dom";
import noUserImg from '../../assets/images/no_user.png';
import { Image } from 'primereact/image';
import { Dialog } from "primereact/dialog";
import { MultiSelect } from "primereact/multiselect";
import { Chip } from 'primereact/chip';
import axios from "axios";
import config from "../../config";
import { useAuth } from "../../context/AuthContext";
import CustomToast from '../../components/CustomToast';
import { MentionsInput, Mention } from 'react-mentions';
const Chat_page = ({ taskId }) => {
  const { accessToken, userId, role } = useAuth();
  const toastRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState('');
  const [activeCommentId, setActiveCommentId] = useState(null);
  const [reply, setReply] = useState("");
  const imageInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const [images, setImages] = useState([]);
  const [documents, setDocuments] = useState([]);
  const MAX_IMAGES = 5;
  const MAX_DOCUMENTS = 5;
  const MAX_TOTAL_SIZE = 15 * 1024 * 1024; // 15MB
  const [commentload, setCommentLoad] = useState(false);

  const showMessage = (severity, detail) => {
    const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
    toastRef.current.show(severity, summary, detail);
  };
  //Reply 
  const imageUploaderRef = useRef(null);
  const documentUploaderRef = useRef(null);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const MAX_IMAGE_COUNT = 5;
  const MAX_DOCUMENT_COUNT = 5;
  const MAX_UPLOAD_SIZE = 15 * 1024 * 1024; // 15MB



  const [comments, setComments] = useState([]);

  const op = useRef(null);
  const op2 = useRef(null);



  // const [visible, setVisible] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [selectedReplyUsers, setSelectedReplyUsers] = useState([]);

  const [visible, setVisible] = useState(false);
  const [visibleReply, setVisibleReply] = useState(false);
  // Fetch users from the API
  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${config.apiBASEURL}/CommentRoutes/fetch-all-users`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      // Format users for MultiSelect (label: full name, value: user_id)
      const formattedUsers = response.data.map(user => ({
        id: user.user_id,
        display: `${user.first_name}_${user.last_name}`, // Display name
      }));

      setUsers(formattedUsers || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [accessToken]);


  const fetchTaskData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.apiBASEURL}/projectRoutes/fetchspecifictask/${taskId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setTask(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTaskData();;
  }, [taskId, accessToken]);



  const fetchComments = async () => {
    try {
      const response = await axios.get(`${config.apiBASEURL}/CommentRoutes/fetch-comments/${taskId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      setComments(response.data.comments);
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
  };

  useEffect(() => {
    if (taskId) {
      fetchComments();
    }
  }, [taskId, accessToken]);


  // Handle comment change and extract mentioned user IDs
  const handleCommentChange = (newValue) => {
    setValue(newValue);
    console.log("newValue:", newValue);

    // Extract mentioned user IDs using correct markup format
    const mentionRegex = /@\[(.*?)\]\(user:(\d+)\)/g;
    let match;
    const mentionedIds = [];

    while ((match = mentionRegex.exec(newValue)) !== null) {
      mentionedIds.push(match[2]); // Extract and store user IDs
    }

    console.log("Mentioned IDs:", mentionedIds);
    setSelectedUsers(mentionedIds);
  };


  // Handle comment change and extract mentioned user IDs
  const handlereplyChange = (newValue) => {
    setReply(newValue);

    // Extract mentioned user IDs using correct markup format
    const mentionRegex = /@\[(.*?)\]\(user:(\d+)\)/g;
    let match;
    const mentionedIds = [];

    while ((match = mentionRegex.exec(newValue)) !== null) {
      mentionedIds.push(match[2]); // Extract and store user IDs
    }

    setSelectedReplyUsers(mentionedIds);
  };


  const handleRemoveUser = (userId) => {
    setSelectedUsers(prev => prev.filter(id => id !== userId));
  };

  const handleRemovereplyUser = (userId) => {
    selectedReplyUsers(prev => prev.filter(id => id !== userId));
  };

  const handleFileChange = (event, type) => {
    const files = Array.from(event.target.files);
    let updatedFiles = type === "image" ? [...images] : [...documents];

    // Check type restrictions
    const isImage = (file) => file.type.startsWith("image/");
    const isValid = files.every((file) =>
      type === "image" ? isImage(file) : !isImage(file)
    );

    if (!isValid) {
      showMessage("error", `Invalid file type selected for ${type}s.`);
      return;
    }

    // Enforce file count limits
    if (updatedFiles.length + files.length > (type === "image" ? MAX_IMAGES : MAX_DOCUMENTS)) {
      showMessage("error", `Maximum ${type === "image" ? MAX_IMAGES : MAX_DOCUMENTS} ${type}s allowed.`);
      return;
    }

    // Calculate total size
    const totalSize = [...images, ...documents, ...files].reduce((acc, file) => acc + file.size, 0);
    if (totalSize > MAX_TOTAL_SIZE) {
      showMessage("error", "Total file size exceeds 15MB limit.");
      return;
    }

    updatedFiles = [...updatedFiles, ...files];

    // Update state
    type === "image" ? setImages(updatedFiles) : setDocuments(updatedFiles);

    // Hide the overlay panel after selection
    op.current?.hide();

  };


  const handleDeleteFile = (type, index) => {
    if (type === "image") {
      setImages(images.filter((_, i) => i !== index));
      showMessage("success", "Image deleted successfully");
    } else {
      setDocuments(documents.filter((_, i) => i !== index));
      showMessage("success", "Document deleted successfully");
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!value.trim()) {
      showMessage("error", "Comment cannot be empty.");
      return;
    }

    const formData = new FormData();
    formData.append("task_id", taskId);
    formData.append("user_id", userId);
    formData.append("comment_text", value);

    // ✅ Send `tagged_users[]` as an array
    if (selectedUsers.length > 0) {
      selectedUsers.forEach((user) => formData.append("tagged_users[]", user));
    }

    // ✅ Append images & documents
    [...images, ...documents].forEach((file) => {
      formData.append("attachments", file);
    });
    setCommentLoad(true); // Start loading
    try {
      const response = await axios.post(
        `${config.apiBASEURL}/CommentRoutes/add-comment`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        showMessage("success", "Comment added successfully!");
        fetchComments();
        setValue("");
        setImages([]);
        setDocuments([]);
        setSelectedUsers([]);
      } else {
        showMessage("error", "Failed to add comment.");
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
      showMessage("error", error?.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setCommentLoad(false); // Stop loading
    }
  };

  /*----------------reply---------------*/

  const [replyVisible, setReplyVisible] = useState({});
  const [replyLoad, setReplyLoad] = useState(false);
  const handleReplyClick = (commentId) => {
    // Reset states if a new comment is selected
    if (activeCommentId !== commentId) {
      setReply(""); // Reset input value
      setSelectedReplyUsers([]); // Clear tagged users
      setUploadedImages([]); // Clear uploaded images
      setUploadedDocuments([]); // Clear uploaded files
    }

    setActiveCommentId(commentId);

    // Ensure only one reply section is open at a time
    setReplyVisible({ [commentId]: true });
  };


  const handleUploadChange = (event, fileType) => {
    const selectedFiles = Array.from(event.target.files);
    let updatedFileList = fileType === "image" ? [...uploadedImages] : [...uploadedDocuments];

    // Validate file type
    const isImageFile = (file) => file.type.startsWith("image/");
    const isValidFile = selectedFiles.every((file) =>
      fileType === "image" ? isImageFile(file) : !isImageFile(file)
    );

    if (!isValidFile) {
      showMessage("error", `Invalid file type selected for ${fileType}s.`);
      return;
    }

    // Enforce file count limits
    if (updatedFileList.length + selectedFiles.length > (fileType === "image" ? MAX_IMAGE_COUNT : MAX_DOCUMENT_COUNT)) {
      showMessage("error", `Maximum ${fileType === "image" ? MAX_IMAGE_COUNT : MAX_DOCUMENT_COUNT} ${fileType}s allowed.`);
      return;
    }

    // Calculate total file size
    const totalUploadedSize = [...uploadedImages, ...uploadedDocuments, ...selectedFiles].reduce((acc, file) => acc + file.size, 0);
    if (totalUploadedSize > MAX_UPLOAD_SIZE) {
      showMessage("error", "Total file size exceeds 15MB limit.");
      return;
    }

    updatedFileList = [...updatedFileList, ...selectedFiles];

    // Update state
    fileType === "image" ? setUploadedImages(updatedFileList) : setUploadedDocuments(updatedFileList);

    // Hide the overlay panel after selection
    op2.current?.hide();
  };

  const removeUploadedFile = (fileType, fileIndex) => {
    if (fileType === "image") {
      setUploadedImages(uploadedImages.filter((_, i) => i !== fileIndex));
      showMessage("success", "Image deleted successfully");
    } else {
      setUploadedDocuments(uploadedDocuments.filter((_, i) => i !== fileIndex));
      showMessage("success", "Document deleted successfully");
    }
  };

  const handlereplySubmit = async (e) => {
    e.preventDefault();

    if (!reply.trim()) {
      showMessage("error", "Reply cannot be empty.");
      return;
    }

    const formData = new FormData();
    formData.append("task_id", taskId);
    formData.append("user_id", userId);
    formData.append("comment_text", reply);
    formData.append("parent_comment_id", activeCommentId);

    // ✅ Send `tagged_users[]` as an array
    if (selectedReplyUsers.length > 0) {
      selectedReplyUsers.forEach((user) => formData.append("tagged_users[]", user));
    }

    // ✅ Append images & documents
    [...uploadedImages, ...uploadedDocuments].forEach((file) => {
      formData.append("attachments", file);
    });

    setReplyLoad(true); // Start loading

    try {
      const response = await axios.post(
        `${config.apiBASEURL}/CommentRoutes/add-reply`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        showMessage("success", "Reply added successfully!");
        fetchComments();
        setReply("");
        setUploadedImages([]);
        setUploadedDocuments([]);
        setSelectedReplyUsers([]);

        // Hide only the reply box for this comment
        setReplyVisible((prev) => ({ ...prev, [activeCommentId]: false }));
      } else {
        showMessage("error", "Failed to add reply.");
      }
    } catch (error) {
      console.error("Error submitting reply:", error);
      showMessage("error", error?.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setReplyLoad(false); // Stop loading
    }
  };


  return (
    <>
      <div className="overflow-y-auto">
        {task && (
          <div className="p-3 bg-light">
            <p className="mb-0" style={{ fontSize: '13px' }}>
              <small className="text-secondary pe-1">Brand :</small>{task.project?.brand?.brand_name}
            </p>
            <p className="mb-0" style={{ fontSize: '13px' }}>
              <small className="text-secondary pe-1">Project :</small>{task.project?.project_name}
            </p>
            <p className="mb-0" style={{ fontSize: '13px' }}>
              <small className="text-secondary pe-1">Task :</small> {task.task_name}
            </p>
          </div>
        )}

        <div className='commebntChatBody p-3'>
          <ul>
            {comments.map(comment => (
              <li key={comment.comment_id}>
                <div className='mainchat'>
                  <div className='chatUser'>
                    <img src={comment.User?.profileImage?.image_url || noUserImg} alt='user' className='rounded-circle' />
                  </div>
                  <div className='chatText'>
                    <h6>
                      {comment.User ? `${comment.User.first_name} ${comment.User.last_name}` : "Unknown User"}
                      <span>{new Date(comment.createdAt).toLocaleString('en-GB')}</span>
                    </h6>
                    <p>{comment.comment_text}</p>
                    <div className='d-flex flex-wrap gap-2 tagChip mb-3'>
                      {comment.Tags.map(tag => (
                        <Chip key={tag.tagged_user_id} label={`@${tag.TaggedUser?.first_name || ''} ${tag.TaggedUser?.last_name || ''}`} />
                      ))}
                    </div>
                    <div className='attach2Div'>
                      <ol>
                        {comment.Attachments.map((attachment, index) => (
                          <li key={index} className="border-0">
                            {attachment.file_type === 'image' ? (
                              <Image src={attachment.file_url} alt='Attachment' className="position-relative chtIMG" preview />
                            ) : (
                              <div className='multiImgChat'>
                                <div className='position-relative mb-3'>
                                  <Link to={attachment.file_url} target='_blank' className="d-flex align-items-center">
                                    <i className='pi pi-file-pdf me-3 text-secondary ' style={{ fontSize: '24px' }}></i><span style={{ wordBreak: 'break-word' }}>{attachment.file_url.split('/').pop()}</span>
                                  </Link>
                                </div>
                              </div>
                            )}
                          </li>
                        ))}
                      </ol>

                    </div>

                    {/*-----------Start of Reply---------------*/}
                    {(comment.Replies?.length === 0) &&
                      <div>
                        <div className='d-flex justify-content-end align-items-center'>
                          <Button
                            label='Reply'
                            icon='pi pi-reply'
                            className='border-0 p-1 opacity-75 mb-2'
                            severity='help'
                            text
                            onClick={() => handleReplyClick(comment.comment_id)} // Pass comment_id
                          />
                        </div>
                        {replyVisible[comment.comment_id] && (
                          <>
                            <div className="bg-light p-3 mb-3">
                              {/* Display Uploaded Documents */}
                              {uploadedDocuments.length > 0 && (
                                <div className="multiImgChat mb-3">
                                  {uploadedDocuments.map((file, index) => (
                                    <div key={index} className="position-relative chtIMG bg-transparent h-auto me-3" style={{ width: 'fit-content' }}>
                                      <Link to="/" target="_blank">
                                        <i className="pi pi-file-pdf me-2"></i> {file.name}
                                      </Link>
                                      <Button
                                        title="delete"
                                        icon="pi pi-times"
                                        className="border-0 p-0"
                                        severity="danger"
                                        text
                                        onClick={() => removeUploadedFile("document", index)}
                                      />
                                    </div>
                                  ))}
                                </div>
                              )}

                              {/* Display Uploaded Images */}
                              {uploadedImages.length > 0 && (
                                <div className="multiImgChat w-100 mb-3">
                                  {uploadedImages.map((file, index) => (
                                    <div key={index} className="position-relative chtIMG">
                                      <Image src={URL.createObjectURL(file)} alt="Uploaded Image" preview />
                                      <Button
                                        title="delete"
                                        icon="pi pi-times"
                                        className="border-0 p-0"
                                        severity="danger"
                                        text
                                        onClick={() => removeUploadedFile("image", index)}
                                      />
                                    </div>
                                  ))}
                                </div>
                              )}
                              {/*-----------Tag Users---------------*/}
                              {selectedReplyUsers.length > 0 && (
                                <div className="d-flex flex-wrap gap-2 tagChip mb-3">
                                  {selectedReplyUsers.map(userId => {
                                    const user = users.find(u => u.value === userId); // Find user in users list
                                    return user ? (
                                      <Chip
                                        key={user.value}
                                        label={`@${user.label}`} // Format as @username
                                        removable
                                        onRemove={() => handleRemovereplyUser(user.value)}
                                        className="px-2 py-1 rounded-pill "
                                      />
                                    ) : null;
                                  })}
                                </div>
                              )}

                              <div className="replyForm">
                                {/* <InputTextarea
                                value={reply}
                                onChange={(e) => setReply(e.target.value)}
                                rows={2}
                                cols={30}
                                className="bg-light"
                                placeholder="Enter your comment here"
                                style={{ height: 'auto' }}
                              /> */}

                                <MentionsInput
                                  value={reply}
                                  onChange={(e) => handlereplyChange(e.target.value)}
                                  className="mentions"
                                  placeholder="Enter your comment here"

                                >
                                  <Mention
                                    trigger="@"
                                    data={users || []}
                                    markup="@[__display__](user:__id__)" // Ensures proper formatting
                                    displayTransform={(id, display) => `@${display}`}
                                    onSearch={(search, callback) => {
                                      const normalizedSearch = search.toLowerCase().replace(" ", "_"); // Convert spaces to underscores
                                      const filtered = users.filter(user =>
                                        user.display.toLowerCase().includes(normalizedSearch)
                                      );
                                      callback(filtered); // Pass the filtered results
                                    }}

                                  />

                                </MentionsInput>


                                <div className="d-flex justify-content-between">
                                  <div>
                                    {/* <Button
                                    title="Tag"
                                    icon="pi pi-at"
                                    className="border-0"
                                    severity="secondary"
                                    text
                                    onClick={() => setVisibleReply(true)}
                                  /> */}

                                    {/* <Dialog
                                    header="Tag Users"
                                    visible={visibleReply}
                                    onHide={() => {
                                      setVisibleReply(false);
                                      setSelectedReplyUsers([]); // Reset selected users when closing
                                    }}
                                    style={{ width: "300px" }}
                                  >
                                    <MultiSelect
                                      value={selectedReplyUsers}
                                      options={users}
                                      onChange={(e) => setSelectedReplyUsers(e.value)}
                                      filter
                                      display="chip"
                                      placeholder="Select Users"
                                      className="w-full"
                                    />
                                    <Button
                                      label="Save"
                                      className="border-0 py-2 mt-3"
                                      severity="info"
                                      onClick={() => setVisibleReply(false)}
                                    />
                                  </Dialog> */}


                                    <Button
                                      title='Attach File'
                                      icon='pi pi-paperclip'
                                      className='border-0'
                                      severity='secondary'
                                      text
                                      onClick={(e) => op2.current.toggle(e)}
                                    />
                                  </div>
                                  <Button
                                    title={replyLoad ? "Submitting..." : "Submit"}
                                    icon={replyLoad ? "pi pi-spin pi-spinner" : "pi pi-send"}
                                    className="border-0"
                                    severity="info"
                                    onClick={handlereplySubmit}
                                    disabled={replyLoad}
                                  />

                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    }
                    {/*-----------End of Reply---------------*/}

                  </div>
                </div>
                <ul>
                  {comment.Replies.map(reply => (
                    <li key={reply.comment_id}>
                      <div className='chatUser'>
                        <img src={reply.User?.profileImage?.image_url || noUserImg} alt='user' className='rounded-circle' />
                      </div>
                      <div className='chatText'>
                        <h6>
                          {reply.User ? `${reply.User.first_name} ${reply.User.last_name}` : "Unknown User"}
                          <span>{new Date(reply.createdAt).toLocaleString('en-GB')}</span>
                        </h6>
                        <p>{reply.comment_text}</p>
                        <div className='d-flex flex-wrap gap-2 tagChip mb-3'>
                          {reply.Tags.map(tag => (
                            <Chip key={tag.tagged_user_id} label={`@${tag.TaggedUser?.first_name || ''} ${tag.TaggedUser?.last_name || ''}`} />
                          ))}
                        </div>
                        <div className='attach2Div'>
                          <ol>
                            {reply.Attachments.map((attachment, index) => (
                              <li key={index} className="border-0">
                                {attachment.file_type === 'image' ? (
                                  <Image src={attachment.file_url} alt='Attachment' className="position-relative chtIMG" preview />
                                ) : (
                                  <div className='multiImgChat'>
                                    <div className='position-relative mb-3'>
                                      <Link to={attachment.file_url} target='_blank' className="d-flex align-items-center">
                                        <i className='pi pi-file-pdf me-3 text-secondary ' style={{ fontSize: '24px' }}></i><span style={{ wordBreak: 'break-word' }}>{attachment.file_url.split('/').pop()}</span>
                                      </Link>
                                    </div>
                                  </div>
                                )}
                              </li>
                            ))}
                          </ol>

                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-auto p-3 bg-light border-top">
        <div>


          {/*-----------DocumentDrive---------------*/}

          {/* Display Uploaded Documents */}
          {documents.length > 0 && (
            <div className="multiImgChat mb-3">
              {documents.map((file, index) => (
                <div key={index} className="position-relative chtIMG bg-transparent h-auto me-3" style={{ width: 'fit-content' }}>
                  <Link to="/" target="_blank">
                    <i className="pi pi-file-pdf me-2"></i> {file.name}
                  </Link>
                  <Button
                    title="delete"
                    icon="pi pi-times"
                    className="border-0 p-0"
                    severity="danger"
                    text
                    onClick={() => handleDeleteFile("document", index)}
                  />
                </div>
              ))}
            </div>
          )}

          {/* Display Uploaded Images */}
          {images.length > 0 && (
            <div className="multiImgChat w-100 mb-3">
              {images.map((file, index) => (
                <div key={index} className="position-relative chtIMG">
                  <Image src={URL.createObjectURL(file)} alt="Uploaded Image" preview />
                  <Button
                    title="delete"
                    icon="pi pi-times"
                    className="border-0 p-0"
                    severity="danger"
                    text
                    onClick={() => handleDeleteFile("image", index)}
                  />
                </div>
              ))}
            </div>
          )}

        </div>
        <div className='d-flex justify-content-between align-items-end'>
          <div>
            {/* <div>
              <Button
                title="Tag"
                icon="pi pi-at"
                className="border-0"
                severity="secondary"
                text
                onClick={() => setVisible(true)}
              />

              <Dialog
                header="Tag Users"
                visible={visible}
                onHide={() => {
                  setVisible(false);
                  setSelectedUsers([]); // Reset selected users when closing
                }}
                style={{ width: "300px" }}
              >
                <MultiSelect
                  value={selectedUsers}
                  options={users}
                  onChange={(e) => setSelectedUsers(e.value)}
                  filter
                  display="chip"
                  placeholder="Select Users"
                  className="w-full"
                />
                <Button
                  label="Save"
                  className="border-0 py-2 mt-3"
                  severity="info"
                  onClick={() => setVisible(false)}
                />
              </Dialog>
            </div> */}
            <Button
              title='Attach File'
              icon='pi pi-paperclip'
              className='border-0'
              severity='secondary'
              text
              onClick={(e) => op.current.toggle(e)}
            />
          </div>
          <div className="px-4 w-100">
            {/* <InputTextarea
              value={value}
              onChange={(e) =>
                setValue(e.target.value)}
              rows={2}
              cols={30}
              className="border-0 border-bottom bg-transparent"
              placeholder="Enter your comment here"
              style={{ height: 'auto' }}
            /> */}
            <MentionsInput
              value={value}
              onChange={(e) => handleCommentChange(e.target.value)}
              className="mentions"
              placeholder="Enter your comment here"

            >
              <Mention
                trigger="@"
                data={users || []}
                markup="@[__display__](user:__id__)" // Ensures proper formatting
                displayTransform={(id, display) => `@${display}`}
                onSearch={(search, callback) => {
                  const normalizedSearch = search.toLowerCase().replace(" ", "_"); // Convert spaces to underscores
                  const filtered = users.filter(user =>
                    user.display.toLowerCase().includes(normalizedSearch)
                  );
                  callback(filtered); // Pass the filtered results
                }}

              />

            </MentionsInput>



          </div>

          <Button
            title={commentload ? "Submitting..." : "Submit"}
            icon={commentload ? "pi pi-spin pi-spinner" : "pi pi-send"}
            className="border-0 p-4"
            severity="info"
            onClick={handleSubmit}
            disabled={commentload}
          />
        </div>
      </div>


      <OverlayPanel ref={op} className="choverpannel">
        <ol className="AttachmentList">
          <li>
            <Link onClick={() => imageInputRef.current.click()}>
              <i className="pi pi-images me-2"></i> Image
            </Link>
            <input
              type="file"
              ref={imageInputRef}
              multiple
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e, "image")}
            />
          </li>
          {/* Document Upload */}
          <li>
            <Link onClick={() => fileInputRef.current.click()}>
              <i className="pi pi-file-pdf me-2"></i> Document
            </Link>
            <input
              type="file"
              ref={fileInputRef}
              multiple
              accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e, "document")}
            />
          </li>
        </ol>
      </OverlayPanel>
      <OverlayPanel ref={op2} className="choverpannel">
        <ol className="AttachmentList">
          <li>
            <Link onClick={() => imageUploaderRef.current.click()}>
              <i className="pi pi-images me-2"></i> Image
            </Link>
            <input
              type="file"
              ref={imageUploaderRef}
              multiple
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => handleUploadChange(e, "image")}
            />
          </li>
          {/* Document Upload */}
          <li>
            <Link onClick={() => documentUploaderRef.current.click()}>
              <i className="pi pi-file-pdf me-2"></i> Document
            </Link>
            <input
              type="file"
              ref={documentUploaderRef}
              multiple
              accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
              style={{ display: "none" }}
              onChange={(e) => handleUploadChange(e, "document")}
            />
          </li>
        </ol>
      </OverlayPanel>
      <CustomToast ref={toastRef} />
    </>
  )
}

export default Chat_page
